// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2c004b37","453":"8d9315bf","455":"bb7c2671","644":"542dacbc"}[chunkId] + ".chunk.js";
};